import(/* webpackMode: "eager" */ "/Users/whw/Desktop/fugufish/vgw-website/frontend/src/app/[locale]/(front-desk)/(pages)/(home)/page.jsx");
